﻿import type { SocialContactType } from '../models';

export type Contacts =
  | ReadonlyArray<{
      readonly type?: SocialContactType | null;
      readonly value?: string | null;
    } | null>
  | null
  | undefined;

export const getContactByType = (
  allowedContacts: Readonly<Array<SocialContactType | null>> | null | undefined,
  contacts: Contacts,
  type: SocialContactType,
) => (allowedContacts?.includes(type) ? contacts?.filter((contact) => contact?.type === type)[0]?.value : null);
